<template>
  <div class="ws-compare-table-item">
    <v-container>
      <v-row>
        <v-col :cols="'6'">
          <WsContent>
            <template>
              <WsInfo
                :type="field.type"
                :label="`前版${field.label}`"
                :value="firstValue ? firstValue : null"
              ></WsInfo>
            </template>
          </WsContent>
        </v-col>
        <v-col :cols="'6'">
          <WsContent>
            <template>
              <WsInfo
                v-if="!isUpdate || (isUpdate && !field.isValueUpdatable)"
                :type="field.type"
                :label="`新版${field.label}`"
                :value="secondValue ? secondValue : null"
              />
              <WsState
                v-else
                :type="field.type"
                :label="field.label"
                :fields="field.fields"
                :rules="field.rules"
                :items="field.items"
                :disabled="field.disabled"
                :modelName="field.modelName"
                :textKey="field.textKey"
                :placeholder="field.placeholder"
                :uploadUrl="field.uploadUrl"
                :note="field.note"
                :maxWidth="field.maxWidth"
                :autofocus="field.autofocus"
                :parent="field.parentKey"
                :parentState="parentState"
                :parentStateName="field.parentStateName"
                :requiredField="field.requiredField"
                :displayLabel="field.displayLabel"
                :excludeSelf="field.excludeSelf"
                :maxlength="field.maxlength"
                :value="value"
                :modelId="id"
                :originValue="secondValue ? secondValue : null"
                :originData="updateData"
                :errorMessage="errorMessage"
                :compareStr="field.compareStr"
                @input="$_onInput($event)"
                @input-item="$emit('input-item',$event)"
              />
            </template>
          </WsContent>
        </v-col>
      </v-row>
      <v-row 
        class="info rounded-lg textPrimary--text"
        v-if="_isCompareSectionShow"
      >
        <v-col>
          <WsContent>
            <WsInfo
              type="stringCompare"
              :label="`比對${field.label}`"
              :value="_stringCompareValue"
            />
          </WsContent>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    _stringCompareValue() {
      if (
        this.firstValue === this.secondValue ||
        typeof this.firstValue !== 'string' ||
        typeof this.secondValue !== 'string'
      ) return [];
      return [
        this.$_setValue(this.firstValue),
        this.$_setValue(this.secondValue),
      ];
    },
    _isCompareSectionShow(){
      return this.firstValue &&
        this.secondValue &&
        typeof this.firstValue === 'string' &&
        typeof this.secondValue === 'string' &&
        this.firstValue !== this.secondValue &&
        (!this.isUpdate || !this.field.isValueUpdatable);
    },
  },
  methods: {
    $_setValue(value){
      return value
      ? (this.field.type === 'date'
      ? this.$moment(value).format("YYYY-MM-DD")
      : value)
      : null
    },
    $_onInput($event){
      this.$emit('input', $event)
    }
  },
  props: {
    firstValue: {
      type: [Array, Object, Number, String],
      default: null,
    },
    secondValue: {
      type: [Array, Object, Number, String],
      default: null,
    },
    field: {
      type: Object,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    parentState: {},
    errorMessage: {
      type: String,
      default: null,
    },
    updateData: {
      type: Object,
    },
    id: {
      type: [Number, String],
      default: null,
    },
    value:{}
  },
};
</script>